import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { Flow } from '../models/flow.model';

@Injectable({ providedIn: 'root' })
export class FlowService extends AbstractService<Flow> {

  getURLBase(): string {
    return '/flow';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Flow): void {
    delete obj?._id;
  }

  preUpdate(obj: Flow): void {
  }

  // POST /api/flow/:id/unpublish — toggles isPublished to false (RF-11). The unconditional
  // confirmation prompt (RF-137) is enforced by the caller before invoking this.
  unpublish(id: string) {
    return super.post(`/${id}/unpublish`, {});
  }

  // GET /api/flow/published-for-picker — company-scoped list of published flows ({ _id, name })
  // for selection dropdowns (e.g. choosing the flow that drives a channel).
  listPublishedForPicker(excludeId?: string): Observable<Array<Pick<Flow, '_id' | 'name'>>> {
    return super.getWithParams('/published-for-picker', excludeId ? { excludeId } : {});
  }

}
